export default __webpack_public_path__ + "static/media/primary-barcode.620e98c6.svg";